import useAccessControl from 'hooks/useAccessControl';

const Authorization = ({ path, children }) => {
	const isAuthorized = useAccessControl();
	return isAuthorized(path) && children;
};

export default Authorization;
